import { GammaSelectOrCreate } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type SelectOrCreateProps<T> = React.ComponentProps<typeof GammaSelectOrCreate.Popover<T>>

type Props<T> = Omit<SelectOrCreateProps<T>, 'selectValue' | 'missingLabel'> & {
  missingLabel?: string
}

function Popover<T>({ missingLabel, ...props }: Props<T>) {
  return (
    <GammaSelectOrCreate.Popover
      {...props}
      missingLabel={missingLabel ?? i18n.t('common.missing_field')}
      selectValue={i18n.t('common.select')}
    />
  )
}

export default {
  Container: GammaSelectOrCreate.Container,
  Option: GammaSelectOrCreate.Option,
  Popover,
}
